'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdSettingsBluetooth = function MdSettingsBluetooth(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm24.8 23.8l-3.2-3.1v6.3z m-3.2-17.4v6.3l3.2-3.2z m7.9 3.1l-7.2 7.1 7.2 7.2-9.5 9.6h-1.6v-12.7l-7.7 7.7-2.3-2.4 9.3-9.4-9.3-9.3 2.3-2.3 7.7 7.7v-12.7h1.6z m-4.5 30.5v-3.4h3.4v3.4h-3.4z m-13.4 0v-3.4h3.4v3.4h-3.4z m6.8 0v-3.4h3.2v3.4h-3.2z' })
        )
    );
};

exports.default = MdSettingsBluetooth;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/settings-bluetooth.js
// module id = 1434
// module chunks = 36573943044255 79611799117203 213534597649335